import React from 'react';
import { User } from '../types';
import { LogOut } from 'lucide-react';

interface UserHeaderProps {
  user: User | null;
  onSignOut: () => void;
}

const UserHeader: React.FC<UserHeaderProps> = ({ user, onSignOut }) => {
  if (!user) {
    return null;
  }

  return (
    <div className="flex items-center gap-3">
      {/* User Info */}
      <div className="flex items-center gap-3 text-sm">
        <div className="w-10 h-10 bg-gradient-to-br from-primary-100 to-primary-200 rounded-full flex items-center justify-center shadow-soft">
          <span className="text-sm font-bold text-primary-700">
            {user.displayName.split(' ').map(name => name.charAt(0)).join('').toUpperCase()}
          </span>
        </div>
        <div className="hidden sm:block">
          <div className="font-semibold text-secondary-800">{user.displayName}</div>
        </div>
        <div className="sm:hidden">
          <div className="font-semibold text-secondary-800">{user.displayName.split(' ')[0]}</div>
        </div>
      </div>
      
      {/* Sign Out Button */}
      <button
        onClick={onSignOut}
        className="btn-secondary flex items-center gap-2 px-4 py-2 text-sm font-medium"
        title="Sign out"
      >
        <LogOut className="w-4 h-4" />
        <span className="hidden sm:inline">Sign out</span>
      </button>
    </div>
  );
};

export default UserHeader;
